import { WarningCircle, Repeat, Hourglass, Bank, EnvelopeSimpleOpen, UsersThree } from "@phosphor-icons/react";
import { C, MONO, Eyebrow } from "./hubShared";

const ICONS = { bounced: WarningCircle, over_mailed: Repeat, opened_stalled: Hourglass, no_debit_order: Bank, no_email: EnvelopeSimpleOpen, shared_email: UsersThree };
const HINT = {
  bounced: "Fix the address, then resend", over_mailed: "Phone them instead of mailing again",
  opened_stalled: "Send a gentle nudge", no_debit_order: "Send only the debit-order form",
  no_email: "Send the WhatsApp invite link", shared_email: "Check these households",
};

export const HubQueues = ({ queues, active, onPick }) => (
  <div data-testid="hub-queues">
    <Eyebrow>Needs attention</Eyebrow>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 8, marginTop: 10 }}>
      {queues.map((q, i) => {
        const Icon = ICONS[q.key];
        const on = active === q.key;
        const hot = q.key === "bounced" || q.key === "over_mailed";
        return (
          <button key={q.key} onClick={() => onPick(on ? "" : q.key)} data-testid={`hub-queue-${q.key}`} className="hub-card"
            style={{ display: "flex", gap: 12, alignItems: "flex-start", textAlign: "left", padding: 14, borderRadius: 10, cursor: "pointer",
              background: on ? C.navy : "#fff", color: on ? "#fff" : C.ink, animationDelay: `${i * 40}ms`,
              border: `1px solid ${on ? C.navy : hot && q.count ? `${C.red}40` : "rgba(26,30,36,0.10)"}` }}>
            <Icon size={20} weight="duotone" color={on ? "#fff" : hot && q.count ? C.red : C.slate} style={{ marginTop: 2, flexShrink: 0 }} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontFamily: MONO, fontWeight: 700, fontSize: 20 }} data-testid={`hub-queue-${q.key}-count`}>{q.count}</div>
              <div style={{ fontSize: 12, fontWeight: 600, marginTop: 2 }}>{q.label}</div>
              <div style={{ fontSize: 11, opacity: 0.65, marginTop: 2 }}>{HINT[q.key]}</div>
            </div>
          </button>
        );
      })}
    </div>
  </div>
);
